module.exports = __webpack_public_path__ + "static/media/sheep.ec5c9ea2.svg";